import axios from "axios";

/** Base HTTP(s) URL without trailing slash. Empty env → same origin (use CRA `proxy` in dev). */
function resolveBackendBase() {
  const env = process.env.REACT_APP_BACKEND_URL?.trim?.() ?? "";
  if (env) return env.replace(/\/$/, "");
  if (typeof window !== "undefined" && window.location?.origin) return window.location.origin;
  return "";
}

const BACKEND_URL = resolveBackendBase();

/**
 * URL do WebSocket alinhada ao mesmo host/protocolo do backend HTTP.
 * Evita mixed content (página https precisa de wss) e same-origin quando BACKEND_URL vazio.
 */
export function buildWebSocketUrl() {
  const base = resolveBackendBase();
  if (!base) {
    if (typeof window !== "undefined" && window.location?.host) {
      const wsProto = window.location.protocol === "https:" ? "wss:" : "ws:";
      return `${wsProto}//${window.location.host}/api/ws`;
    }
    return "ws://127.0.0.1:8000/api/ws";
  }
  if (base.startsWith("https://")) {
    return `${base.replace(/^https:\/\//, "wss://")}/api/ws`;
  }
  return `${base.replace(/^http:\/\//, "ws://")}/api/ws`;
}

const api = axios.create({
  baseURL: BACKEND_URL ? `${BACKEND_URL}/api` : "/api",
  withCredentials: true,
  timeout: 15000,
  headers: { "Content-Type": "application/json" },
});

export default api;
export { BACKEND_URL };

export function formatApiError(detail) {
  if (detail == null) return "Algo deu errado. Tente novamente.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => {
        if (!e || typeof e !== "object") return JSON.stringify(e);
        const loc = Array.isArray(e.loc) ? e.loc.filter(Boolean).join(".") : "";
        const msg = typeof e.msg === "string" ? e.msg : typeof e.message === "string" ? e.message : "";
        const one = [loc && `(${loc})`, msg || JSON.stringify(e)].filter(Boolean).join(" ");
        return one.trim() || JSON.stringify(e);
      })
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  if (detail && typeof detail === "object") {
    const m = detail.response?.message ?? detail.message;
    if (Array.isArray(m) && m.length) return m.map((x) => (typeof x === "string" ? x : JSON.stringify(x))).join("; ");
    if (typeof m === "string" && m.trim()) return m;
    try {
      return JSON.stringify(detail);
    } catch {
      return String(detail);
    }
  }
  return String(detail);
}
